import { c as _c } from "react/compiler-runtime";
import { theme } from '@cc-shopping/ui/theme';
import { useMediaQuery } from '@mui/material';
import { CommonApprovalOdds } from './CommonApprovalOdds';
import { MobileContainer } from './Mobile.container';
export function RecommendedCreditScoreMobile() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = theme.breakpoints.down("sm");
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const isMobile = useMediaQuery(t0);
  let t1;
  if ($[1] !== isMobile) {
    t1 = <MobileContainer><CommonApprovalOdds smallApprovalLabelText={isMobile} /></MobileContainer>;
    $[1] = isMobile;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}